import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyBNiGLL_GY40FsX4DkJMYYL-V8UjfX8Zsk",
    authDomain: "fairplay-ar.firebaseapp.com",
    databaseURL: "https://fairplay-ar.firebaseio.com",
    projectId: "fairplay-ar",
    storageBucket: "fairplay-ar.appspot.com",
    messagingSenderId: "697336086143",
    appId: "1:697336086143:web:90f7ec7c74902407bac94a",
    measurementId: "G-XPY1GEMK21"
};

class Firebase {
    constructor() {

        if (!firebase.apps.length) {
            firebase.initializeApp(config);
        }
        this.auth = firebase.auth();
        this.functions = firebase.functions();
        this.firestoree = firebase.firestore;
        this.firestore = firebase.firestore();
        this.storage = firebase.storage();


    }

    // *** Auth API ***

    doCreateUserWithEmailAndPassword = (email, password) =>
        this.auth.createUserWithEmailAndPassword(email, password);

    doSignInWithEmailAndPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => this.auth.signOut();

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

    doPasswordChange = password =>
        this.auth.currentUser.updatePassword(password);



    // *** Batch to write transaction
    batch = () => this.firestore.batch();

    // *** TimeStamp
    timestamp = () => this.firestoree.FieldValue.serverTimestamp();

    store = () => {
        // if (process.env.NODE_ENV == 'production') {
        //     return this.firestore.collection("DBs").doc("production")
        // }
        return this.firestore
    }
    // *** Premium User API ***
    premiumUserList = () => this.firestore.collection('premium_users').orderBy('createdAt', 'desc');
    premiumUserCollection = () => this.firestore.collection('premium_users');
    premiumUserDoc = (uid) => this.firestore.collection('premium_users').doc(uid);

    // *** Ads API ***
    adsList = () => this.firestore.collection('ads').orderBy('createdAt', 'desc');
    adsCollection = () => this.firestore.collection('ads');
    adsDoc = (uid) => this.firestore.collection('ads').doc(uid);


    // *** Tournament API ***
    tournamentList = (userId) => this.store().collection('tournaments').doc(userId)
        .collection('tournaments').orderBy('createdAt', 'desc');
    tournamentCollection = (userId) => this.store().collection('tournaments').doc(userId)
        .collection('tournaments');
    tournamentDoc = (userId, uid) => this.store().collection('tournaments').doc(userId)
        .collection('tournaments').doc(uid);

    // *** Team API ***
    teamList = (userId, tournamentId) => this.store().collection('teams').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('teams').orderBy('title');
    teamCollection = (userId, tournamentId) => this.store().collection('teams').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('teams');
    teamDoc = (userId, tournamentId, uid) => this.store().collection('teams').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('teams').doc(uid);
    teamDocPlayers = (userId, tournamentId, uid, playerId) => this.store().collection('teams').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('teams').doc(uid).collection('players').doc(playerId);

    // *** Matches API ***
    matchList = (userId, tournamentId) => this.store().collection('matches').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('matches');
    matchCollection = (userId, tournamentId) => this.store().collection('matches').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('matches');
    matchDoc = (userId, tournamentId, uid) => this.store().collection('matches').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('matches').doc(uid);

    // *** Players API ***
    playerList = (userId, tournamentId, teamId) => this.store().collection('players').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('players').where('teamUid', '==', teamId).orderBy('name');
    playerCollection = (userId, tournamentId) => this.store().collection('players').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('players');
    playerDoc = (userId, tournamentId, uid) => this.store().collection('players').doc(userId)
        .collection('tournaments').doc(tournamentId).collection('players').doc(uid);




    // *** Matches collectionGroup ***
    matchesCollectionGroup = (userId) => this.firestore.collectionGroup('matches')
        .where('userUid', '==', userId);


    // *** Matches collectionGroup ***
    tournamentsCollectionGroup = () => this.firestore.collectionGroup('tournaments');
    // .where('userUid', '==', userId);




    // *** Storage API ***
    files = () => this.storage.ref('files');
    folder = (folder) => this.storage.ref('images').child(folder);
    file = (folder, filename) => this.folder(folder).child(filename);


    // *** Functions API ***
    addAdminRole = () => this.functions.httpsCallable('addAdminRule');

    createUserPremium = () => this.functions.httpsCallable('createUserPremium');
    deleteUser = () => this.functions.httpsCallable('deleteUser');
    deleteTournamentAdmin = () => this.functions.httpsCallable('deleteTournamentAdmin');
    deleteAd = () => this.functions.httpsCallable('deleteAd');
    enableDisableUser = () => this.functions.httpsCallable('enableDisableUser');

    createTournament = () => this.functions.httpsCallable('createTournament');
}

export default Firebase;